import { CandidateUsername } from "@generated/graphql";

export const getTelegramUserName = (
  candidateUsername: Pick<CandidateUsername, "telegramUsername"> | undefined | null
) => {
  const telegramUsername = candidateUsername?.telegramUsername;
  if (telegramUsername) {
    return `@${telegramUsername}`;
  }
  return "";
};

export const modifyTelegramUsername = (value: string) => {
  return value.startsWith("@") ? value : `@${value}`;
};
